import React, { useState, useEffect } from 'react';

import './CommunityOnboarding.scss';
import { useRouter } from 'next/router';
import icons from '../../../shared/assets/icons/redesign';
import { getPregnancyPeriod } from '../../../helpers/date';
import Popup from '../../redesign/Popup/Popup.jsx';
import { getString } from '../../../helpers/styles';
import Transition from '../../Transition/Transition.jsx';
import {
  DateInput,
  BirthDateCalculator
} from '../../redesign/Onboarding/Onboarding.jsx';
import { mutationFormat } from '../../../helpers/date';
import { getCommunityMemberCount, isPartner } from '../../../helpers/user';
import CommunityLoginPopupContent from '../../redesign/PopupContent/CommunityLoginPopupContent/CommunityLoginPopupContent.jsx';
import CommunityTermsPopupContent from '../../redesign/PopupContent/CommunityTermsPopupContent/CommunityTermsPopupContent.jsx';

const { Logo, CalendarSimple } = icons;

export default function CommunityOnboarding({
  user,
  loginUrl,
  signupUrl,
  userGroups,
  userJoinGroup,
  changeUserData
}) {
  const router = useRouter();
  const [hash, setHash] = useState();

  const [selectedDate, setSelectedDate] = useState(null);
  const [birthDateCalculator, showBirthDateCalculator] = useState(false);
  const [birthDateCalculationResult, showBirthDateCalculationResult] =
    useState();

  const displayedBirthDateCalculationResult =
    birthDateCalculationResult?.date?.toLocaleString('nl-NL', {
      month: 'long',
      year: 'numeric'
    });

  useEffect(() => {
    const hash = window.location.hash.slice(1);

    if (!hash) return;

    !user.username && ['edd', 'edd-calculated', 'voorwaarden'].includes(hash)
      ? setHash()
      : setHash(hash);
  }, [user.username]);

  useEffect(() => {
    history.replaceState({}, '', hash ? `#${hash}` : ' ');
  }, [hash]);

  return (
    <div className="componentWrap">
      <div className="communityOnboarding-header">
        <Logo />

        <div
          className="communityOnboarding-close-button"
          onClick={() => router.back()}
        >
          &times;
        </div>
      </div>

      {renderContent(hash)}
    </div>
  );

  function renderContent(hash) {
    switch (hash) {
      case 'edd':
      case 'edd-calculated':
        return birthDateCalculator ? (
          birthDateCalculationResult ? (
            <div className="text-center">
              <h3 className="communityOnboarding-title">
                <div className="communityOnboarding-icon-wrap">
                  <CalendarSimple className="communityOnboarding-calendar-icon" />
                </div>
                Je bent uitgerekend in de maand
                <br />
                <span className="communityOnboarding-text-marked">
                  {displayedBirthDateCalculationResult}
                </span>
              </h3>

              <p
                className="
              communityOnboarding-text
              communityOnboarding-text-normal
            "
              >
                Wil je deelnemen aan de geboortegroep van{' '}
                {displayedBirthDateCalculationResult}?
              </p>

              <div className="communityOnboarding-fixed">
                <button
                  onClick={() => {
                    changeUserData({
                      variables: {
                        edd: mutationFormat(birthDateCalculationResult.date),
                        eddStatus: 'OK'
                      }
                    });

                    const group = (userGroups || []).find(({ uri }) => {
                      const month = displayedBirthDateCalculationResult.replace(
                        ' ',
                        '-'
                      );

                      return uri === (isPartner(user) ? `${month}-p` : month);
                    });

                    if (!group) return;

                    userJoinGroup({
                      variables: {
                        userGroupXuid: group.xuid
                      }
                    });
                  }}
                  className="community-button"
                >
                  Deelnemen
                </button>

                <button
                  className="
                  community-button
                  community-button-secondary
                "
                  onClick={() => showBirthDateCalculationResult(false)}
                >
                  Bereken opnieuw
                </button>
              </div>
            </div>
          ) : (
            <div className="communityOnboarding-birth-date-calculator">
              <BirthDateCalculator
                onCalculate={() => setHash('edd-calculated')}
                showBirthDateCalculationResult={showBirthDateCalculationResult}
              />
            </div>
          )
        ) : (
          <>
            <h3 className="communityOnboarding-title">
              Bevestig je uitgerekende datum
            </h3>

            <div className="communityOnboarding-date-input">
              <DateInput
                placeholder="Uitgerekende datum"
                selected={user.edd ? new Date(user.edd) : selectedDate}
                period={getPregnancyPeriod()}
                title="Aanpassen van uitgerekende datum"
                onDateChange={(date) => setSelectedDate(date)}
              />
            </div>
            <p
              className="communityOnboarding-link"
              onClick={() => showBirthDateCalculator(true)}
            >
              Ik weet het niet – Datum berekenen
            </p>

            <button
              onClick={() => {
                showBirthDateCalculator(true);
                showBirthDateCalculationResult({
                  date: new Date(selectedDate || user.edd)
                });
              }}
              className={getString([
                {
                  value: 'community-button communityOnboarding-fixed',
                  condition: true
                },
                {
                  value: 'community-button-disabled',
                  condition: !user.edd && !selectedDate
                }
              ])}
            >
              Bevestigen
            </button>
          </>
        );

      default:
        return (
          <>
            <Transition on={hash === 'create-account'}>
              <div className="popup-wrapper">
                <Popup onClose={() => setHash()}>
                  <CommunityLoginPopupContent
                    loginUrl={loginUrl}
                    signupUrl={signupUrl}
                  />
                </Popup>
              </div>
            </Transition>

            <Transition on={hash === 'voorwaarden'}>
              <div className="popup-wrapper">
                <Popup onClose={() => setHash()}>
                  <CommunityTermsPopupContent onAgree={() => setHash('edd')} />
                </Popup>
              </div>
            </Transition>

            <h1 className="communityOnboarding-title">
              Welkom bij community groepen!
            </h1>

            <p className="communityOnboarding-text">
              Om deel te nemen aan communities moet je in het bezit zijn van een
              account en akkoord gaan met de community voorwaarden.
            </p>

            <div>
              <span className="communityOnboarding-text-small">
                <span className="bold">
                  {getCommunityMemberCount(userGroups)} anderen
                </span>{' '}
                doen mee.
              </span>
            </div>

            <a className="communityOnboarding-link" href={loginUrl}>
              Ik heb geen account - Ik wil een account aanmaken
            </a>

            <button
              onClick={() =>
                user.username
                  ? setHash('voorwaarden')
                  : setHash('create-account')
              }
              className="community-button communityOnboarding-fixed"
            >
              Verder
            </button>
          </>
        );
    }
  }
}
